<template>
  <div class="d-flex align-center">
    <v-icon color="#0d4663" size="60" class="mr-n10 mt-n2px">mdi-arrow-left-bold</v-icon>
    <div id="retangulo">
      MAIS BAIXO MENOR É A IMPORTÂNCIA
    </div>
  </div>
</template>

<script>
export default {
  name: "IndicadorImportancia"
}
</script>

<style scoped>
#retangulo {
  height: 18px;
  width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  //background: #0d4663;
  color: white;
  font-size: 11px;
  z-index: 999;
  background-image: linear-gradient(to right, #0d4663, white);
}
.mt-n2px {
  margin-top: -2px;
}
</style>
